<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card header="Exportaciones">
          <div class="form-group form-inline pull-left">
            <select v-model="numPages" class="form-control">
              <option
                v-for="(num, k) in [10, 30, 50, 100]"
                :key="k"
                :value="num"
              >
                {{ num }}
              </option></select
            >&nbsp;
            <input
              v-model="search"
              type="search"
              class="form-control"
              placeholder="Buscar"
            />
            &nbsp;
          </div>
          <div class="form-group form-inline pull-right">
            <date-picker
              v-model="date.start"
              lang="es"
              type="date"
              placeholder="Desde"
              required
              format="DD/MM/YYYY"
            ></date-picker
            >&nbsp;
            <date-picker
              v-model="date.end"
              lang="es"
              type="date"
              placeholder="Hasta"
              required
              format="DD/MM/YYYY"
            ></date-picker
            >&nbsp;
            <button class="btn btn-primary" @click="getRqs()">Buscar</button
            >&nbsp;
            <download-excel
              class="btn btn-primary"
              :data="filteredRqs"
              :fields="json_fields"
              name="Exportaciones_no_asignadas.xls"
              >Descargar Excel
            </download-excel>
          </div>
          <div class="table-responsive rqTable">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>
                    <a href="javscript:void(0)" @click="sort('tax_paid')">
                      Gate Out
                      <i
                        v-if="currentSort === 'tax_paid'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('id')">
                      #RQ
                      <i
                        v-if="currentSort === 'id'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a
                      href="javscript:void(0)"
                      @click="sort('service.doc_number')"
                    >
                      BL/Booking
                      <i
                        v-if="currentSort === 'service.doc_number'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('date')">
                      Fecha (cita)
                      <i
                        v-if="currentSort === 'date'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a
                      href="javscript:void(0)"
                      @click="sort('service.company.name')"
                    >
                      Cliente
                      <i
                        v-if="currentSort === 'service.company.name'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a
                      href="javscript:void(0)"
                      @click="sort('service.company.company_bill.name')"
                    >
                      Facturar a
                      <i
                        v-if="
                          currentSort === 'service.company.company_bill.name'
                        "
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('address.alias')">
                      Dirección/Zona
                      <i
                        v-if="currentSort === 'address.alias'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a
                      href="javscript:void(0)"
                      @click="sort('deposit_pick.name')"
                    >
                      Depósito de retiro
                      <i
                        v-if="currentSort === 'deposit_pick.name'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('deposit.name')">
                      Depósito de entrega Full
                      <i
                        v-if="currentSort === 'deposit.name'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('date_fill')">
                      Fecha de llenado
                      <i
                        v-if="currentSort === 'date_fill'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a
                      href="javscript:void(0)"
                      @click="sort('container_number')"
                    >
                      Contenedor
                      <i
                        v-if="currentSort === 'container_number'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a
                      href="javscript:void(0)"
                      @click="sort('container_size.name')"
                    >
                      Tamaño contenedor
                      <i
                        v-if="currentSort === 'container_size.name'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a
                      href="javscript:void(0)"
                      @click="sort('charge_type.name')"
                    >
                      Tipo de carga
                      <i
                        v-if="currentSort === 'charge_type.name'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('custody.name')">
                      Resguardo
                      <i
                        v-if="currentSort === 'custody.name'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                  <th>Solicitante</th>
                  <th>Creado el</th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('status.name')">
                      Estado
                      <i
                        v-if="currentSort === 'status.name'"
                        :class="`fa fa-sort-${
                          currentSortDir === 'asc' ? 'up' : 'down'
                        }`"
                      ></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="17" align="center">
                    <i class="fa fa-lg fa-spinner fa-spin"></i>
                  </td>
                </tr>
                <tr
                  v-else
                  @contextmenu.prevent="selectRq(rq)"
                  v-for="(rq, k) in paginated('filteredRqs')"
                  :key="k"
                >
                  <td>
                    <input
                      type="checkbox"
                      v-model="rq.tax_paid"
                      @click="setTax(rq)"
                      :disabled="!$can('manage', 'Requeriments')"
                    />
                  </td>
                  <td>
                    {{ rq.id }}
                    <span
                      v-if="rq.driver_confirm === constants.RECHAZA_CONDUCTOR"
                      title="Rechazado por conductor"
                      ><i class="fa fa-times"></i
                    ></span>
                  </td>
                  <td>{{ rq.service.doc_number }}</td>
                  <td>{{ rq.date | formatDateTime }}</td>
                  <td>
                    {{ rq.service.company ? rq.service.company.name : "" }}
                  </td>
                  <td>
                    {{
                      rq.service.company
                        ? rq.service.company.company_bill.name
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      rq.address
                        ? `${rq.address.alias} - ${rq.address.place.name}`
                        : ""
                    }}
                  </td>
                  <td>{{ rq.deposit_pick ? rq.deposit_pick.name : "--" }}</td>
                  <td>{{ rq.deposit ? rq.deposit.name : "--" }}</td>
                  <td>{{ rq.date_fill | formatDateTime }}</td>
                  <td>{{ rq.container_number }}</td>
                  <td>
                    {{
                      rq.charge_type.name !== constants.SUELTA
                        ? rq.container_size.name
                        : "--"
                    }}
                  </td>
                  <td>{{ rq.charge_type.name }}</td>
                  <td>
                    {{
                      rq.guard
                        ? rq.custody
                          ? rq.custody.name
                          : "Si, custodia no indicada"
                        : "No"
                    }}
                  </td>
                  <td>
                    {{
                      rq.service.applicant
                        ? `${rq.service.applicant.name} ${rq.service.applicant.last_name}`
                        : ""
                    }}
                  </td>
                  <td>{{ rq.created_at | formatDateTime }}</td>
                  <td>{{ rq.status ? rq.status.name : "" }}</td>
                </tr>
              </tbody>
            </table>
            <paginate
              name="filteredRqs"
              :list="filteredRqs"
              class="paginate-list"
              :per="numPages"
              :refreshCurrentPage="false"
            ></paginate>
            <paginate-links
              for="filteredRqs"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<',
              }"
              :classes="{
                ul: 'pagination',
                li: 'page-item',
                a: 'page-link',
              }"
            ></paginate-links>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <context-menu id="context-menu" ref="ctxMenu">
      <li
        v-on:click="showModal = true"
        class="ctx-item"
        v-if="$can('manage', 'Requeriments')"
      >
        Asignar
      </li>
      <li @click="detailRq" class="ctx-item">Detalle</li>
      <li
        @click="editRq()"
        class="ctx-item"
        v-if="$can('manage', 'Requeriments')"
      >
        Editar
      </li>
      <li
        v-on:click="cancel()"
        class="ctx-item"
        v-if="$can('manage', 'Requeriments')"
      >
        Anular
      </li>
      <li
        v-on:click="endRq()"
        class="ctx-item"
        v-if="$can('manage', 'Requeriments')"
      >
        Finalizar
      </li>
    </context-menu>
    <ModalTrucks
      :showModal="showModal"
      :requeriment="rq"
      :statuses="statuses"
      @close="showModal = false"
    />

    <ModalSubjects
      :showModalSubjects="showModalSubjects"
      :rq="rq"
      @sendSubjects="sendSubjects"
      @close="showModalSubjects = false"
    />
    <div
      v-if="showModal || showModalSubjects"
      class="modal-backdrop fade show"
    ></div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import contextMenu from "vue-context-menu";
import ModalTrucks from "./ModalTrucks";
import ModalSubjects from "./ModalSubjects";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: { ModalTrucks, contextMenu, ModalSubjects },
  data() {
    return {
      isDisabled: false,
      paginate: ["filteredRqs"],
      json_fields: {
        "#Servicio": "service.id",
        "#RQ": "id",
        "BL/Booking": "service.doc_number",
        "Fecha (cita)": {
          field: "date",
          callback: (value) => {
            return moment(value).format("DD/MM/YYYY HH:mm");
          },
        },
        Cliente: "service.company.name",
        "Facturar a": "service.company.company_bill.name",
        Direccion: {
          field: "address.alias",
          callback: (value) => {
            return value ? value : "";
          },
        },
        Zona: "address.place.name",
        "Deposito de retiro": {
          field: "deposit_pick",
          callback: (deposit_pick) => {
            return deposit_pick ? deposit_pick.name : "";
          },
        },
        "Deposito de entrega Full": {
          field: "deposit",
          callback: (deposit) => {
            return deposit ? deposit.name : "";
          },
        },
        "Fecha de llenado": {
          field: "date_fill",
          callback: (value) => {
            return moment(value).isValid()
              ? moment(value).format("DD/MM/YYYY HH:mm")
              : "";
          },
        },
        Contenedor: "container_number",
        Tamano: {
          field: "container_size",
          callback: (value) => {
            return value.name ? value.name : "--";
          },
        },
        "Tipo de carga": "charge_type.name",
        Resguardo: {
          field: "guard",
          callback: (value) => {
            return value ? "SI" : "NO";
          },
        },
        Solicitante: {
          field: "service",
          callback: (service) => {
            return service.applicant
              ? `${service.applicant.name} ${service.applicant.last_name}`
              : "";
          },
        },
        "Creado el": {
          field: "created_at",
          callback: (value) => {
            return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
          },
        },
      },
      rqs: [],
      numPages: 100,
      statuses: [],
      rq: {},
      loading: true,
      search: "",
      showModal: false,
      showModalSubjects: false,
      truckSelected: null,
      date: {
        start: moment().format("YYYY-MM-DD 00:00"),
        end: moment().format("YYYY-MM-DD 23:59:59"),
      },
      currentSort: "id",
      currentSortDir: "asc",
    };
  },
  computed: {
    ...mapGetters({ user: "user/user" }),
    filteredRqs() {
      const searchWord = this.search.toLowerCase();
      return this.rqs
        .filter((rq) => {
          let condition = ![
            constants.PENDIENTE,
            constants.ANULADO_TRAMARSA,
            constants.CANCELADO_CLIENTE,
            constants.DRAFT,
            constants.FINALIZADO,
          ].includes(rq.status.code);

          const companyCondition = this.searchCondition(
            rq.service.company.name
          );
          const companyBillCondition = this.searchCondition(
            rq.service.company.company_bill.name
          );
          const docCondition = this.searchCondition(rq.service.doc_number);
          const containerCondition = this.searchCondition(rq.container_number);
          const chargeTypeCondition = this.searchCondition(rq.charge_type.name);
          const addressCondition = rq.address
            ? this.searchCondition(
                `${rq.address.alias} - ${rq.address.place.name}`
              )
            : false;
          const depositPickCondition = rq.deposit_pick
            ? this.searchCondition(rq.deposit_pick.name)
            : false;
          const depositCondition = rq.deposit
            ? this.searchCondition(rq.deposit.name)
            : false;
          const sizeCondition = rq.container_size
            ? this.searchCondition(rq.container_size.name)
            : false;
          const guardCondition =
            rq.guard && rq.custody
              ? this.searchCondition(rq.custody.name)
              : false;
          const statusCondition = rq.status
            ? this.searchCondition(rq.status.name)
            : false;

          if (this.search) {
            condition =
              condition &&
              (companyCondition ||
                companyBillCondition ||
                docCondition ||
                addressCondition ||
                depositPickCondition ||
                depositCondition ||
                containerCondition ||
                guardCondition ||
                chargeTypeCondition ||
                sizeCondition ||
                statusCondition ||
                searchWord === rq.id.toString());
          }
          return condition;
        })
        .sort((objA, objB) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          let a = _.get(objA, this.currentSort);
          let b = _.get(objB, this.currentSort);
          if (!a) a = "";
          if (!b) b = "";
          if (a < b) return -1 * modifier;
          if (a > b) return 1 * modifier;
          return 0;
        });
    },
  },
  mounted() {
    this.getRqs();
    api.get("/statuses").then((response) => {
      this.statuses = response.status;
    });
  },
  methods: {
    setTax(rq) {
      this.loading = true;
      api
        .put(`/requeriments/${rq.id}`, { tax_paid: !rq.tax_paid })
        .then((response) => {
          this.showSuccess("Actualizado.", "Pago de Gate out");
          this.loading = false;
        });
    },
    showSuccess(label, title) {
      this.$toastr.success(label, title, {
        positionClass: "toast-top-center",
        closeButton: true,
      });
    },
    searchCondition(field) {
      const searchWord = this.search.toLowerCase();
      return (field || "").toLowerCase().includes(searchWord);
    },
    getRqs() {
      this.constants = constants;
      this.loading = true;
      const data = {
        service_code: [constants.EXPORTACION],
        finish: false,
        assigned: false,
        date_start: moment(this.date.start).format("YYYY-MM-DD 00:00"),
        date_end: moment(this.date.end).format("YYYY-MM-DD 23:59"),
      };
      api.post("list_requeriments", data).then((response) => {
        this.rqs = response.requeriments;
        this.loading = false;
      });
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    detailRq() {
      this.$router.push(`/requeriments/import/detail/${this.rq.id}`);
    },
    editRq() {
      let route = this.$router.resolve({
        path: `/requeriment/edit/${this.rq.id}`,
      });
      window.open(route.href, "_blank");
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    endRq() {
      const question = `¿Seguro desea finalizar el requerimiento #${this.rq.id}`;
      if (confirm(question)) this.updateRq(constants.FINALIZADO, "finalizado");
    },
    updateRq(status, label, subjects = null) {
      let data = {
        status_id: this.statuses.find((st) => st.code === status).id,
        truck_id: null,
        driver_id: null,
      };

      api.put(`/requeriments/${this.rq.id}`, data).then((response) => {
        if (response.success) {
          api
            .post("/action_logs/", {
              rq_id: this.rq.id,
              comments: this.capitalize(label),
              subjects,
            })
            .then((res) => console.log(res));

          this.$toastr.success(`Requerimiento ${label}.`, "Requerimiento", {
            positionClass: "toast-top-center",
            closeButton: true,
          });

          if (this.rq.driver_id) {
            let data_push = {
              user_id: this.rq.driver_id,
              headings: `Requerimiento ${label}`,
              contents: label,
              data: { requeriment_id: this.rq.id },
            };
            api.post("/send_push", data_push).then((response) => {
              console.log(response);
            });
          }

          // this.$socket.emit("updateRequerimentServer", response.requeriment);
        }
      });
    },
    cancel() {
      const question = `¿Seguro desea anular el requerimiento #${this.rq.id}`;
      if (confirm(question)) this.showModalSubjects = true;
    },
    sendSubjects(subjects) {
      const status = constants.ANULADO_TRAMARSA;
      this.showModalSubjects = false;
      this.updateRq(status, "anulado", subjects);
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    updateRequeriment: function (rq) {
      const index = this.rqs.findIndex((r) => r.id === rq.id);
      if (index >= 0) {
        if (!rq.truck_id) this.rqs.splice(index, 1, rq);
        else if (rq.truck_id) this.rqs.splice(index, 1);
      }
    },
    addRequeriment: function (rq) {
      if (rq.service.code === constants.EXPORTACION) {
        this.rqs.push(rq);
      }
    },
  },
};
</script>
<style scoped>
th a {
  color: #000 !important;
}
</style>
